'use es6';

import { createSelector } from 'reselect';
import I18n from 'I18n';
import { toMoment } from 'UIComponents/core/SimpleDate';
import { getAdAccounts, getFilterableAdAccounts } from './AccountsSelectors';
import { getTeamsInfo } from 'AdsUI/selectors/UsersAndTeamsSelectors';
import { getHubSpotUserId, hasContentTeamAssignmentScope } from 'AdsUI/selectors/AuthSelectors';
import { USERS_AND_TEAMS_TYPE, CUSTOM_IDS, Networks } from 'AdsUI/lib/Constants';
import { getAccountsForUser, getTeamsForUser } from 'AdsUI/lib/UsersAndTeamsUtils';
export const getRawGlobalFilters = state => state.globalFilters;
export const getSelectedAdAccounts = createSelector(getRawGlobalFilters, getAdAccounts, (globalFilters, adAccounts) => globalFilters.adAccounts.map(({
  accountId,
  network
}) => adAccounts.find(account => account.accountId === accountId && account.network === network)));
export const getGlobalFilters = createSelector(getRawGlobalFilters, getSelectedAdAccounts, (globalFilters, selectedAdAccounts) => globalFilters.set('adAccounts', selectedAdAccounts));
export const getTimeRange = createSelector(getGlobalFilters, globalFilters => globalFilters.timeRange);
export const getSelectedUsersAndTeams = createSelector(getGlobalFilters, globalFilters => globalFilters.usersAndTeams);
export const getFilteredAdAccounts = createSelector(getAdAccounts, getFilterableAdAccounts, (adAccounts, filterableAdAccounts) => adAccounts.filter(adAccount => filterableAdAccounts.find(filterableAccount => filterableAccount.id === adAccount.id && filterableAccount.network === adAccount.network)));
export const getAdAccountsByUserAndTeams = createSelector(getFilteredAdAccounts, getSelectedUsersAndTeams, getTeamsInfo, getHubSpotUserId, hasContentTeamAssignmentScope, (adAccounts, usersAndTeams, teamsInfo, hubspotUserId, hasAccessToContentTeamAssignmentScope) => {
  const type = usersAndTeams.get('type');
  const id = usersAndTeams.get('id');

  switch (type) {
    case USERS_AND_TEAMS_TYPE.TEAM:
      {
        return adAccounts.filter(account => account.adAccountAssignees.length === 0 || account.adAccountAssignees.find(assignee => assignee.id === id && assignee.assigneeType === USERS_AND_TEAMS_TYPE.TEAM));
      }

    case USERS_AND_TEAMS_TYPE.USER:
      {
        return getAccountsForUser(id, teamsInfo, adAccounts);
      }

    case USERS_AND_TEAMS_TYPE.CUSTOM:
      {
        if (id === CUSTOM_IDS.ASSIGNED_TO_USER) {
          return getAccountsForUser(hubspotUserId, teamsInfo, adAccounts);
        } else if (id === CUSTOM_IDS.ASSIGNED_TO_USERS_TEAM) {
          const teamsForUser = getTeamsForUser(hubspotUserId, teamsInfo);
          return adAccounts.filter(account => account.adAccountAssignees.length === 0 || account.adAccountAssignees.find(assignee => teamsForUser.includes(assignee.id) && assignee.assigneeType === USERS_AND_TEAMS_TYPE.TEAM));
        } else if (hasAccessToContentTeamAssignmentScope && id === CUSTOM_IDS.ALL) {
          return adAccounts;
        } else {
          return getAccountsForUser(hubspotUserId, teamsInfo, adAccounts);
        }
      }

    default:
      {
        return adAccounts;
      }
  }
});
export const filtersIncludePurgedDates = createSelector(getSelectedAdAccounts, getTimeRange, (adAccounts, timeRange) => adAccounts.filter(adAccount => adAccount.network === Networks.LINKEDIN).size > 0 && toMoment(timeRange.startDate).isSameOrBefore(I18n.moment.portalTz().subtract(1, 'year')));
export const filtersIncludeFacebookStaleDateRange = createSelector(getSelectedAdAccounts, getTimeRange, (adAccounts, timeRange) => adAccounts.some(adAccount => adAccount.network === Networks.FACEBOOK) && toMoment(timeRange.endDate).isSameOrAfter(I18n.moment.portalTz().subtract(3, 'day')));